module.exports = __webpack_public_path__ + "media/8_1.88e6db6b.mp4";